/**
 * @generated SignedSource<<bf93b5e5898172a512863253b577b2ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleLeadingImagesContent$data = {
  readonly headline: string | null | undefined;
  readonly images: ReadonlyArray<{
    readonly isSlideshow: boolean | null | undefined;
    readonly size1020x680: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly size1200x800: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly size1280x720: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly size1320w: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly size1676x943: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly size660w: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly size768x768: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly sizeLandscape250x99: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly title: string | null | undefined;
    readonly type: string | null | undefined;
    readonly url: string;
  } | null | undefined> | null | undefined;
  readonly leadingSlides?: ReadonlyArray<{
    readonly size1020x680: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly size1200x800: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly size1280x720: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly size1320w: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly size1676x943: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly size660w: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly size768x768: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly sizeLandscape250x99: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly title: string | null | undefined;
    readonly type: string | null | undefined;
    readonly url: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "articleLeadingImagesContent";
};
export type articleLeadingImagesContent$key = {
  readonly " $data"?: articleLeadingImagesContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleLeadingImagesContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "alias": "size660w",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "660w"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": "style(filter:{\"style\":\"660w\"})"
},
v5 = {
  "alias": "size1320w",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "1320w"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1320w\"})"
},
v6 = {
  "alias": "sizeLandscape250x99",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "landscape_250_99"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
},
v7 = {
  "alias": "size1280x720",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "wide_landscape"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
},
v8 = {
  "alias": "size1676x943",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "wide_landscape_style"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": "style(filter:{\"style\":\"wide_landscape_style\"})"
},
v9 = {
  "alias": "size1200x800",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "1200x800"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1200x800\"})"
},
v10 = {
  "alias": "size1020x680",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "1020x680"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1020x680\"})"
},
v11 = {
  "alias": "size768x768",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "768x768"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": "style(filter:{\"style\":\"768x768\"})"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleLeadingImagesContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSlideshow",
          "storageKey": null
        },
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/)
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "leadingSlides",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "Article",
      "abstractKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};
})();

(node as any).hash = "58833bd399eefa6774990ee1bc1b4ce6";

export default node;
